import { styled } from '@slal/ui';
import { Input } from '@slal/ui/forms';
import { TextField as SUITextField } from '@slal/ui/react-hook-form/fields';
import { Article } from '@slal/ui/typography';

export const relatedFieldIndent = '44px';

export const StyledForm = styled.form`
    h3,
    h4 {
        margin-bottom: ${({ theme }) => theme.space[3]};
    }
`;

export const StyledFieldSet = styled.fieldset`
    margin: 0 0 ${({ theme }) => theme.space[7]};
    padding: 0;
    border: 0;
`;

export const StyledFormIntroduction = styled(Article)`
    margin-bottom: ${({ theme }) => theme.space[5]};
    p {
        margin-top: -${({ theme }) => theme.space[5]};
    }
`;

const getSize = (size?: number) => {
    if (!size) return '100%';
    switch (size) {
        case 4:
            return '80px';
        case 3:
            return '68px';
        case 2:
            return '56px';
        default:
            return '44px';
    }
};

export const StyledInput = styled(Input)`
    width: ${({ size }) => getSize(size)};
    margin-right: ${({ size, theme }) => (size ? theme.space[4] : '0')};
`;

export const StyledDateFieldSet = styled(StyledFieldSet)`
    padding-top: ${({ theme }) => theme.space[2]};
    margin: 0;
    label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-size: inherit;
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;

export const TextField = styled(SUITextField)`
    width: ${({ size }) => getSize(size)};
`;
